import BaseStore from '../../../../../components/BaseStore'

export default {
  extends: BaseStore,
  props: {
    condition: {
      required: true,
      type: Object
    },
    // config: {
    //   required: true,
    //   type: Object
    // },
    auditTypes: {
      required: true,
      type: Array
    },
    dataTypes: {
      required: true,
      type: Array
    },
    sites: {
      required: true,
      type: Array
    },
    siteFactorMap: {
      required: true,
      type: Object
    },
    stepData: {
      required: true,
      type: Object
    },
    sourceType: {
      required: true,
      type: Number
    }
  },
  computed: {
    auditTypeMap () {
      return this.auditTypes.reduce((map, auditType) => {
        map[auditType.value] = auditType
        return map
      }, {})
    },
    auditType () {
      return this.auditTypeMap[this.condition.auditType]
    },
    dataTypeMap () {
      return this.dataTypes.reduce((map, dataType) => {
        map[dataType.value] = dataType
        return map
      }, {})
    },
    dataType () {
      return this.dataTypeMap[this.condition.dataType]
    },
    currentFactorMap () {
      return this.siteFactorMap[this.condition.siteId] || {
        map: {}
      }
    },
    currentSiteFactors () {
      return Object.values(this.currentFactorMap.map || {})
    },
    formatFactorGroups () {
      const {factorGroupMap} = this
      return Object.values(this.currentSiteFactors.reduce((map, factor) => {
        const {parentId} = factor
        let newFactorGroup = map[parentId]

        if (!newFactorGroup) {
          const factorGroup = factorGroupMap[parentId]

          if (!factorGroup) {
            return map
          }

          newFactorGroup = map[parentId] = {
            id: parentId,
            name: factorGroup.name,
            children: []
          }
        }

        newFactorGroup.children.push({
          id: factor.factorId,
          name: factor.name
        })

        return map
      }, {}))
    },
    site () {
      return this.profileSiteMap[this.condition.siteId]
    }
  },
  methods: {
    nextStep () {
      return Promise.resolve()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/BaseStep.js